module.exports = __webpack_public_path__ + "static/media/consumer.ea2d1d90.svg";